const classIn = {
  path: 'classIn/:courseId',
  component: resolve => require(['../../../pages/user/classin'], resolve),
  props: true
}

export default classIn



// WEBPACK FOOTER //
// ./src/router/user/classin/index.js